module.exports = __webpack_public_path__ + "static/media/07.a5f9d2cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/07.jpg
// module id = 376
// module chunks = 0